import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    apercuShow : false,
    modelShow : false,
    GoVierge: false,
    GoVentes: false,
    ajoutsuccess : false,
    modifsuccess : false,
    current : [],
    listclients : [],
}

const Factures = createSlice({
    name : 'FacturesData',
    initialState,
    reducers :{
        ajoutsuccess:(state,action) =>{
            state.ajoutsuccess=action.payload
        },
        modifsuccess:(state,action) =>{
            state.modifsuccess=action.payload
        },
        currentelement:(state,action) =>{
            state.current=action.payload
        },
        showapercu:(state,action) =>{
            state.apercuShow=action.payload
        },
        listclients:(state,action) =>{
            state.listclients=action.payload
        },
        showmodel:(state,action) =>{
            state.modelShow=action.payload
        },
        govierge:(state,action) =>{
            state.GoVierge=action.payload
        },
        goventes:(state,action) =>{
            state.GoVentes=action.payload
        },
    }
})

export const {ajoutsuccess,currentelement,modifsuccess,showapercu,listclients,showmodel,govierge,goventes} = Factures.actions
export default Factures.reducer;